<template>
	<ViewLayout>
		<template #header-title>
			Log Viewer
		</template>
		<template #header-after>
			<Tabs
				:tab.sync="tab"
				:tabs="tabs"
			/>
		</template>
		<template #content>
			<TabItems
				:tab="tab"
				:tabs="tabs"
			>
				<template #0>
					<SubmissionsTab
						:submissions="submissions"
					/>
				</template>
				<template #1>
					<SubmissionFailuresTab
						:submission-failures="submissionFailures"
					/>
				</template>
				<template #2>
					<ConnectorServiceFailuresTab
						:integration-failures="integrationFailures"
					/>
				</template>
			</TabItems>
		</template>
	</ViewLayout>
</template>

<script>
import 'vue-json-pretty/lib/styles.css'
import ViewLayout from '../../../../../../shared/layouts/view-layout.vue'
import { getSubmissionLogs, getSubmissionFailures, getIntegrationFailures } from '../../../../../../shared/utils/api/log-viewer.js'
import Tabs from '../../../../../../shared/components/tabs.vue'
import TabItems from '../../../../../../shared/components/tab-items.vue'
import SubmissionsTab from './submissions-tab.vue'
import SubmissionFailuresTab from './submission-failures-tab.vue'
import ConnectorServiceFailuresTab from './connector-service-tab.vue'

export default {
	components: { ViewLayout, Tabs, TabItems, SubmissionsTab, SubmissionFailuresTab, ConnectorServiceFailuresTab },
	data () {
		return {
			tabs: [{ title: 'Submissions', slot: '0', icon: 'mdi-database-plus-outline' }],
			tab: '0',
			submissions: {},
			submissionFailures: {},
			integrationFailures: {}
		}
	},
	async created () {
		this.loadLogs()
		// Added populateOptionalTabs() in case we need to control visibilty of tabs.
		// If it's uneccessary, then just add tabs direct to tabs array in data object
		// and remove the method.
		this.populateOptionalTabs()
	},
	methods: {
		async loadLogs () {
			const { data: submissions } = await getSubmissionLogs()
			const { data: submissionFailures } = await getSubmissionFailures()
			const { data: integrationFailures } = await getIntegrationFailures()
			this.submissions = submissions
			this.submissionFailures = submissionFailures
			this.integrationFailures = integrationFailures
		},
		populateOptionalTabs () {
			this.tabs.push({ title: 'Submission Failures', slot: '1', icon: 'mdi-database-remove-outline' })
			this.tabs.push({ title: 'Connector Service Failures', slot: '2', icon: 'mdi-chart-line-variant' })
		}
	}
}
</script>
